import React from 'react';

const Footer = ({ children }) => {
    return (
        <footer className='h-18 bg-auth bg-center bg-cover'>
            <div className='h-18 max-w-3xl w-full mx-auto'>{children}</div>
        </footer>
    );
};

export default Footer;
